import React, { useState, useEffect } from "react";
import leftArrow from '../Images/arrowleft.png'; 
import rightArrow from '../Images/arrowright.png'; 
import shoppingCart from '../Images/arrow-shop.png'; 
import massege from '../Images/arrow-massege.png'; 
import TrophyIcon from '../Images/cup.svg'; 
import TruckIcon from '../Images/car.svg'; 
import TagIcon from '../Images/wallet.png';
import { useNavigate } from "react-router-dom";
import axios from 'axios';


const OnlinePrintingShop = () => {

  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesData, setSlidesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
   // Fetch slider data from API
   useEffect(() => {
    const fetchSlides = async () => {
      setIsLoading(true);

      try {
        const response = await fetch("https://backend.printtrio.co.uk/api/home/get-sliders");
        const result = await response.json();
        if (result.success) {
          setSlidesData(result.data || []);
        }
      } catch (error) {
        console.error("Error fetching slides:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSlides();
  }, []);

  const handleButtonClick = async (slide) => {
    if (!slide) return;
  
    switch (slide.cta_type) {
      case "collection":
        try {
          const response = await fetch("https://backend.printtrio.co.uk/api/product/get-products", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ categoryId: slide.cta_url }),
          });
  
          const data = await response.json();
  
          if (data.success) {
            navigate("/collection", {
              state: {
                scrollToPromo: true,
                products: data.data,
                collectionName: slide.title,
                collectionDescription: slide.description,
              },
            });
          }
        } catch (error) {
          console.error("Error fetching products for collection:", error);
        }
        break;
  
      case "category":
        try {
          const response = await axios.get("https://backend.printtrio.co.uk/api/category/get-category");
          if (response.data.success) {
            const category = response.data.data.find(cat => cat.id === parseInt(slide.cta_url, 10));
            if (category) {
              navigate("/Category-name", {
                state: {
                  categoryId: category.id,
                  categoryName: category.name,
                  banner: category.banner,
                  scrollToPromo: true,
                },
              });
            } else {
              console.error("Category not found for cta_url:", slide.cta_url);
            }
          }
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
        break;
  
        case "product":
          navigate('/product', {
            state: { 
              scrollToPromo: true,
              productId: slide.cta_url, // Pass the productId from slide.cta_url
            },
          });
          break;
  
      default:
        console.error("Unhandled cta_type:", slide.cta_type);
    }
  };
  
  
  // const slides = [

  //   (
  //     <div className=" px-6 flex flex-col  md:flex-row justify-between items-center" style={{height:'294px'}}>
  //     <div className="flex-1">
  //       <h1 className="text-white font-bold text-4xl md:text-4xl xl:text-6xl leading-tight mb-4 px-0 xl:px-20">
  //         Online Printing Shop All In One
  //       </h1>
  //       <p className="text-white text-opacity-80 mb-8 px-0 xl:px-20">
  //         Lorem Ipsum Dolor Sit Amet Consectetur. Dolor Cursus Mattis Rhoncus Natoque Risus Proin Pharetra Lacus Vitae.
  //       </p>
  //       <div className="flex items-center ">
  //       <button className=" text-white py-3 px-3 xl:px-6 rounded-full font-medium  transition duration-300 ml-0 xl:ml-20 flex items-center gap-2 xl:gap-3" style={{backgroundColor:'#EC008C'}}>
  //         <p className=" text-sm ">Shop Now</p>
  //         <img src={shoppingCart} alt="Shop" className= "w-4 xl:w-5 h-auto " /> 
  //       </button>

  //       <img src={massege} alt="Description" className="w-8 h-auto ml-6" />
  //       </div>

  //     </div>
      
  //   </div>
  //   ),


  // ];

  const nextSlide = () => setCurrentSlide((currentSlide + 1) % slidesData.length);

  // Function to navigate to the previous slide
  const prevSlide = () => setCurrentSlide((currentSlide - 1 + slidesData.length) % slidesData.length);


  return (
       <>
    {isLoading ? (
      <div className="flex justify-center items-center h-screen">
        {/* Tailwind simple spinner */}
        <svg
          className="animate-spin h-12 w-12 text-pink-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    ) : (
      <>
   <div className="w-full bg-white">
  <div className="max-w-screen-xl mx-auto relative ">
    {slidesData.length > 0 ? (
   <div
  className="w-full flex flex-col justify-center relative"
  style={{
    backgroundImage: `url(https://backend.printtrio.co.uk/${slidesData[currentSlide]?.image})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    aspectRatio: '16 / 6', 
    
  }}
>

   
        {/* <div className="absolute left-0 ml-8 xl:ml-40 flex items-center justify-center h-full cursor-pointer" onClick={prevSlide}>
        <img src={leftArrow} alt="Left Arrow" className="h-auto w-5" />
      </div> */}

 {/* Arrow Controls */}
 <div className="absolute inset-y-0 left-0 right-0 flex justify-between items-center pointer-events-none px-4 xl:px-20">
                <div
                  className="pointer-events-auto cursor-pointer"
                  onClick={prevSlide}
                >
                  <img src={leftArrow} alt="Left Arrow" className="h-auto w-5" />
                </div>
                <div
                  className="pointer-events-auto cursor-pointer"
                  onClick={nextSlide}
                >
                  <img src={rightArrow} alt="Right Arrow" className="h-auto w-5" />
                </div>
              </div>

       {/* Slide Content */}
       <div className="px-6 flex flex-col md:flex-row justify-between items-start md:items-center ml-10" >
            <div className="flex-1">
              <h1 className="text-white font-semibold mt-0 md-mt-0 text-xl md:text-4xl xl:text-6xl leading-tight mb-4 lg:px-16">
                {slidesData[currentSlide]?.title}
              </h1>
              <p className="text-white text-xs md:text-xl  mb-2 md:mb-8 xl:mb-20 lg:px-16 w-40 md:w-full max-w-2xl">
                {slidesData[currentSlide]?.description}
              </p>
              <div className="flex items-center mt-0 xl:mt-10 lg:px-10">
                <button
                  className="text-white py-2 md:py-3 px-3 xl:px-6 rounded-full font-medium transition duration-300 ml-5 flex items-center gap-2 xl:gap-3"
                  style={{ backgroundColor: '#EC008C' }}
                  onClick={() => handleButtonClick(slidesData[currentSlide])}
                >
                  <p className="text-xs md:text-sm">{slidesData[currentSlide]?.button_text}</p>
                  <img src={shoppingCart} alt="Shop" className="w-4 xl:w-5 h-auto" />
                </button>
                {/* <img src={massege} alt="Description" className="w-8 h-auto ml-6" /> */}
              </div>
            </div>
          </div>


    
      {/* <div className="absolute right-0 mr-8 xl:mr-40 flex items-center justify-center h-full cursor-pointer" onClick={nextSlide}>
        <img src={rightArrow} alt="Right Arrow" className="h-auto w-5" />
      </div> */}


      <div className="flex items-center justify-end space-x-2">
  {slidesData.map((_, index) => (
    <span key={index}
          style={{
            width: currentSlide === index ? '20px' : '8px',
            backgroundColor: currentSlide === index ? '#ec008c' : 'white',
            opacity: currentSlide === index ? '2' : '0.5',
          }}
          
    ></span>
  ))}
</div>




    </div>
 ) : (
   <div>Loading slides...</div>
 )}
</div>
</div>
    <div className=" flex flex-col  md:flex-row justify-between items-start md:items-center  px-20 md:px-16 xl:px-48 space-y-12 md:space-y-0  bg-white py-8 md:py-8 max-w-screen-2xl mx-auto px-4 xl:px-20">
      <div className="flex flex-row items-center gap-4 pl-0 md:pl-1">
        <img src={TrophyIcon} alt="Premium Quality" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl  mt-2">Premium Quality Made In The UK</p>
      </div>
      <div className="flex flex-row items-center gap-4">
        <img src={TruckIcon} alt="Fast Delivery" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl mt-2">Fast Production And Delivery</p>
      </div>
      <div className="flex flex-row items-center gap-4 ">
        <img src={TagIcon} alt="Low Price" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl mt-2">Low Price And Low Quantity Orders</p>
      </div>
    </div>

    </>
      )}
    </>


  );
};

export default OnlinePrintingShop;
